import { render, staticRenderFns } from "./IconTrash.vue?vue&type=template&id=0b07ea3c"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"
import style0 from "./IconTrash.vue?vue&type=style&index=0&id=0b07ea3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports